/*
 * @Author: chi.yong chi.yong@jitai.ai
 * @Date: 2024-05-10 14:39:15
 * @LastEditors: chi.yong chi.yong@jitai.ai
 * @LastEditTime: 2025-04-30 13:33:06
 * @FilePath: /JTFE_home_user/src/router/index.ts
 * @Description: router setting
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { createRouter, createWebHistory } from 'vue-router';

import { canAccessWithRestrictedApplyStatus, isPublicPath, isRestrictedApplyStatus } from '@/router/access.ts';
import { useUserStore } from '@/stores/userStore.ts';

const isLoading = ref(false);

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // 捕获所有未知路由并重定向到首页
    {
      path: '/:catchAll(.*)',
      redirect: '/aomView'
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/login/RegisterPage.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/LoginPage.vue')
    },
    {
      path: '/forgetPass',
      name: 'forgetPass',
      component: () => import('@/views/login/ForgetPass.vue')
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import('@/views/pricing/Pricing.vue')
    },
    {
      path: '/index',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
      children: [
        {
          path: '/account',
          name: 'account',
          component: () => import('@/views/account/Account.vue')
        },
        {
          path: '/productManual',
          name: 'productManual',
          component: () => import('@/views/account/ProductManual.vue')
        },
        {
          path: '/show',
          name: 'show',
          component: () => import('@/views/account/Show.vue')
        },
        {
          path: '/stock',
          name: 'stock',
          redirect: '/aomView'
        },
        {
          path: '/sage',
          name: 'sage',
          redirect: '/strategyFilter'
        },
        {
          path: '/aomView',
          name: 'aomView',
          component: () => import('@/views/stock/aom/Aom.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/aomCorrelation',
          name: 'aomCorrelation',
          component: () => import('@/views/stock/aom/AomCorrelation.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/indexFilter',
          name: 'indexFilter',
          component: () => import('@/views/stock/aom/IndexFilter.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/indexGlobalView',
          name: 'indexGlobalView',
          component: () => import('@/views/stock/aom/IndexGlobalView.vue'),
          meta: { section: 'stock', menuIndex: 'indexFilter' }
        },
        {
          path: '/indexView',
          name: 'indexView',
          component: () => import('@/views/stock/aom/IndexView.vue'),
          meta: { section: 'stock', menuIndex: 'indexFilter' }
        },
        {
          path: '/industryFilter',
          name: 'industryFilter',
          component: () => import('@/views/stock/industry/IndustryFilter.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/industryView',
          name: 'industryView',
          component: () => import('@/views/stock/industry/IndustryView.vue'),
          meta: { section: 'stock', menuIndex: 'industryFilter' }
        },
        {
          path: '/industryCorrelation',
          name: 'industryCorrelation',
          component: () => import('@/views/stock/industry/IndustryCorrelation.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/industryTendency',
          name: 'industryTendency',
          component: () => import('@/views/stock/industry/IndustryTendency.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/industryTreeMap',
          name: 'industryTreeMap',
          component: () => import('@/views/stock/industry/IndustryTreeMap.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/tickerView',
          name: 'tickerView',
          component: () => import('@/views/stock/ticker/TickerView.vue'),
          meta: { section: 'stock', menuIndex: 'tickerFilter' }
        },
        {
          path: '/tickerFilter',
          name: 'tickerFilter',
          component: () => import('@/views/stock/ticker/TickerFilter.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/fundView',
          name: 'fundView',
          component: () => import('@/views/stock/fund/FundView.vue'),
          meta: { section: 'stock', menuIndex: 'fundFilter' }
        },
        {
          path: '/fundCompany',
          name: 'fundCompany',
          component: () => import('@/views/stock/fund/FundCompany.vue'),
          meta: { section: 'stock', menuIndex: 'fundCompanyFilter' }
        },
        {
          path: '/fundManager',
          name: 'fundManager',
          component: () => import('@/views/stock/fund/FundManager.vue'),
          meta: { section: 'stock', menuIndex: 'fundManagerFilter' }
        },
        {
          path: '/fundFilter',
          name: 'fundFilter',
          component: () => import('@/views/stock/fund/FundFilter.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/fundCompanyFilter',
          name: 'fundCompanyFilter',
          component: () => import('@/views/stock/fund/FundCompanyFilter.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/fundManagerFilter',
          name: 'fundManagerFilter',
          component: () => import('@/views/stock/fund/FundManagerFilter.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/selfSelected',
          name: 'selfSelected',
          component: () => import('@/views/stock/SelfSelected.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/bondView',
          name: 'bondView',
          component: () => import('@/views/stock/macro/BondView.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/commodityView',
          name: 'commodityView',
          component: () => import('@/views/stock/macro/CommodityView.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/forexFilter',
          name: 'forexFilter',
          component: () => import('@/views/stock/macro/ForexFilter.vue'),
          meta: { section: 'stock' }
        },
        {
          path: '/forexView',
          name: 'forexView',
          component: () => import('@/views/stock/macro/ForexView.vue'),
          meta: { section: 'stock', menuIndex: 'forexFilter' }
        },
        {
          path: '/strategyFilter',
          name: 'strategyFilter',
          component: () => import('@/views/sage/StrategyFilter.vue'),
          meta: { section: 'sage' }
        },
        {
          path: '/strategyPFilter',
          name: 'strategyPFilter',
          component: () => import('@/views/sage/StrategyPFilter.vue'),
          meta: { section: 'sage' }
        },
        {
          path: '/strategyView',
          name: 'strategyView',
          component: () => import('@/views/sage/StrategyView.vue'),
          meta: { section: 'sage', menuIndex: 'strategyFilter' }
        },
        {
          path: '/strategyPView',
          name: 'strategyPView',
          component: () => import('@/views/sage/StrategyPView.vue'),
          meta: { section: 'sage', menuIndex: 'strategyPFilter' }
        },
        {
          path: '/productFilter',
          name: 'productFilter',
          component: () => import('@/views/sage/ProductFilter.vue'),
          meta: { section: 'sage' }
        },
        {
          path: '/productView',
          name: 'productView',
          component: () => import('@/views/sage/ProductView.vue'),
          meta: { section: 'sage', menuIndex: 'productFilter' }
        },
        {
          path: '/seFilter',
          name: 'seFilter',
          component: () => import('@/views/sage/SEFilter.vue'),
          meta: { section: 'sage' }
        },
        {
          path: '/seView',
          name: 'seView',
          component: () => import('@/views/sage/SEView.vue'),
          meta: { section: 'sage', menuIndex: 'seFilter' }
        },
        {
          path: '/seBackTestView',
          name: 'seBackTestView',
          component: () => import('@/views/sage/SEBackTestView.vue'),
          meta: { section: 'sage', menuIndex: 'seFilter' }
        },
        {
          path: '/tradeFilter',
          name: 'tradeFilter',
          component: () => import('@/views/sage/TradeFilter.vue'),
          meta: { section: 'sage' }
        },
        {
          path: '/tradeView',
          name: 'tradeView',
          component: () => import('@/views/sage/TradeView.vue'),
          meta: { section: 'sage', menuIndex: 'tradeFilter' }
        }
      ]
    },
    {
      // 同步页
      path: '/syncView',
      name: 'syncView',
      component: () => import('@/views/stock/SyncView.vue')
    }
  ]
});

router.beforeEach((to, from) => {
  isLoading.value = true; // 开始加载
  const userStore = useUserStore();
  const isToken = userStore.userInfo.Authorization;
  const applyStatus = userStore.userInfo.apply_status;
  if (to.path === '/') {
    return '/aomView';
  }
  if (to.path === '/index') {
    // 跳转到官网
    window.location.replace('http://www.jitai.info');
  }
  if (!isToken && !isPublicPath(to.path)) {
    // 如果没有 token，只能访问登录、注册、忘记密码等页面
    ElMessage({
      message: `无权访问，请登录`,
      type: 'error'
    });
    return '/login';
  }

  // 如果已登录且申请状态受限，只允许访问个人相关页面
  if (isToken && isRestrictedApplyStatus(applyStatus) && !canAccessWithRestrictedApplyStatus(to.path)) {
    return '/account';
  }
});

router.afterEach(() => {
  isLoading.value = false; // 结束加载
  // 每次路由切换后重置滚动位置
  window.scrollTo(0, 0);
});
export { isLoading };
export default router;
